'use client';
import type { TriggerEventParams } from '@unifyapps/defs/hooks/useBlockEvents';
import type { EventTypeEnum } from '@unifyapps/defs/types/event';
import _noop from 'lodash/noop';
import { createContext, useContext } from 'react';
import { EMPTY_ARRAY } from '../../../consts/empty';

export type BlockEventsGatewayContextType = {
  canTriggerEvents: boolean;
  whitelistedEvents: EventTypeEnum[];
  onAddWaitingEventCallback?: (eventId: string) => void;
  filterWaitingEvents?: (events: TriggerEventParams[]) => TriggerEventParams[];
};

const DEFAULT_CONTEXT: BlockEventsGatewayContextType = {
  canTriggerEvents: true,
  whitelistedEvents: EMPTY_ARRAY as EventTypeEnum[],
  onAddWaitingEventCallback: _noop,
  filterWaitingEvents: (events: TriggerEventParams[]) => events,
};

export const BlockEventsGatewayContext =
  createContext<BlockEventsGatewayContextType>(DEFAULT_CONTEXT);

export const useBlockEventsGateway = () => {
  const context = useContext(BlockEventsGatewayContext);

  if (!context) {
    return DEFAULT_CONTEXT;
  }

  return context;
};
